import { LOGOUT_PAGE } from 'constants/pages'
import {
  SETTINGS_BILLING_PAGE,
  SETTINGS_REDIRECT_INTEGRATION_PAGE,
} from 'subapps/settings/types'

export const ALLOWED_EXPIRED_BILLING = [
  SETTINGS_REDIRECT_INTEGRATION_PAGE,
  LOGOUT_PAGE,
  SETTINGS_BILLING_PAGE,
]
